import * as actions from '../actions'

const defaultState = null

export default function menu(state = defaultState, action) {
    switch (action.type) {
        case actions.MENU_CONFIG:
            if (!action.error) {
                state = action.payload.data
            }
            return Object.assign({}, state)

        case actions.CLEAN_ALL:
        case actions.APP_SELECT:
            return defaultState

        default:
            return state
    }
}
